<template>
  <div>
    <div class="card card-box card-reviewer-feedback">
      <div class="card-header bg-light">
        <div class="card-header--title">
          <div class="font-weight-bold">Reviewer feedback</div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="latestReviewFeedback" id="ReviewerProfile">
          <div class="text-dark mb-4">
            {{ formatDateTimeDefault(latestReviewFeedback.created_at) }} time
          </div>
          <BaseUserProfile :user-name="reviewerFullName">
            <template slot="name">
              <div class="ml-2">
                <div ref="reviewer--fullname" class="text-dark">
                  {{ reviewerFullName }}
                </div>
                <div ref="reviewer--reponse" class="mt-3">
                  <span v-safe-html="latestReviewFeedback.review_response"></span>
                </div>
              </div>
            </template>
          </BaseUserProfile>

          <BaseFilesList
            v-if="latestReviewFeedback.attachments && latestReviewFeedback.attachments.length > 0"
            class="mt-4 attachment__post"
            :attachments="latestReviewFeedback.attachments"
          />
        </div>
      </div>

      <div v-if="reviewFeedbacksWithoutLatestReviewFeedback.length" class="card-footer">
        <b-button variant="primary" @click="show = true">View previous feedback</b-button>

        <BaseModal
          id="ModalViewAllReviewerFeedback"
          title="View previous feedback"
          size="xl"
          :show.sync="show"
        >
          <div v-if="reviewFeedbacks && reviewFeedbacks.length" id="ReviewerProfileAll">
            <div
              v-for="reviewFeedback in reviewFeedbacksWithoutLatestReviewFeedback"
              :key="reviewFeedback.id"
            >
              <div class="reviwer-feedback-info">
                <div class="text-dark mb-4">
                  {{ formatDateTimeDefault(reviewFeedback.created_at) }}
                  time
                </div>
                <BaseUserProfile
                  :user-name="`${reviewFeedback.reviewer.firstname} ${reviewFeedback.reviewer.lastname}`"
                >
                  <template slot="name">
                    <div class="ml-2">
                      <div ref="reviewer--fullname" class="text-dark">
                        {{
                          `${reviewFeedback.reviewer.firstname} ${reviewFeedback.reviewer.lastname}`
                        }}
                      </div>
                      <div ref="reviewer--reponse" class="mt-3">
                        <span
                          v-if="reviewFeedback.review_response"
                          v-safe-html="reviewFeedback.review_response"
                        ></span>
                        <span v-else class="text-muted">(No text response provided)</span>
                      </div>
                    </div>
                  </template>
                </BaseUserProfile>

                <BaseFilesList
                  v-if="reviewFeedback.attachments && reviewFeedback.attachments.length > 0"
                  class="mt-4 attachment__post"
                  :attachments="reviewFeedback.attachments"
                />
              </div>
            </div>
          </div>
          <template #modal-footer>
            <div>
              <b-button variant="link" class="btn__close" @click="show = false"> Close </b-button>
            </div>
          </template>
        </BaseModal>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewFeedback from '@/models/ReviewFeedback';
import LearningUnit from '@/models/LearningUnit';
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import { datetimeMixin } from '../../../mixins/datetimeMixin';
import BaseFilesList from '@/components/base-components/BaseFilesList';
import BaseModal from '@/components/base-components/BaseModal';

export default {
  components: { BaseUserProfile, BaseFilesList, BaseModal },
  mixins: [datetimeMixin],

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    reviewFeedbacks() {
      return ReviewFeedback.query()
        .where('learning_unit_id', this.learningUnit.id)
        .orderBy('created_at', 'desc')
        .get();
    },

    latestReviewFeedback() {
      return ReviewFeedback.query()
        .where('learning_unit_id', this.learningUnit.id)
        .orderBy('created_at', 'desc')
        .first();
    },

    reviewFeedbacksWithoutLatestReviewFeedback() {
      return this.reviewFeedbacks
        ? this.reviewFeedbacks.filter((feedback) => feedback.id != this.latestReviewFeedback.id)
        : [];
    },

    reviewerFullName() {
      let username = '';

      if (this.latestReviewFeedback && this.latestReviewFeedback) {
        username = `${this.latestReviewFeedback.reviewer.firstname} ${this.latestReviewFeedback.reviewer.lastname}`;
      }

      return username;
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      await ReviewFeedback.api().fetch({
        learning_unit: this.learningUnit.id
      });
      this.$emit('fetch:success');
    }
  }
};
</script>

<style lang="scss">
#ModalViewAllReviewerFeedback .modal-dialog .modal-content {
  height: 90vh !important;

  .modal-body {
    padding: 0;
    overflow-y: auto;
  }
}

.reviwer-feedback-info {
  padding: 1rem;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #d1d2db;
}

.card-reviewer-feedback {
  width: 680px;
  background: #ffffff;
  border: 1px solid #d1d2db;
  box-sizing: border-box;
  box-shadow: 0px 4px 8.8px rgba(166, 166, 185, 0.55);
  border-radius: 10.4px;
}

#ReviewerProfile .container__user-profile,
#ReviewerProfileAll .container__user-profile {
  align-items: flex-start !important;
}

.text__user-fullname {
  word-break: break-word;
}
</style>
